<app-base-white-messages-index
[getTableDataApiMethodName]="getTableDataApiMethodName"
[pageTitle]="pageTitle"
[isShowOperationBtns]="false"
[pageTagName]="tagName"
>
</app-base-white-messages-index>
